module.exports = __webpack_public_path__ + "img/5C045C_BD0DBD_930493_A404A4-256px.11c909c3.png";